// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-219a1ffb] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.textarea[data-v-219a1ffb] {
  position: relative;
  width: 100%;
  border-radius: var(--border-radius-large);
  margin-block-start: 6px;
  resize: vertical;
}
.textarea__main-wrapper[data-v-219a1ffb] {
  position: relative;
}
.textarea--disabled[data-v-219a1ffb] {
  opacity: .7;
  filter: saturate(.7);
}
.textarea__input[data-v-219a1ffb] {
  margin: 0;
  padding-inline: 10px 6px;
  width: 100%;
  font-size: var(--default-font-size);
  text-overflow: ellipsis;
  background-color: var(--color-main-background);
  color: var(--color-main-text);
  border: 2px solid var(--color-border-maxcontrast);
  border-radius: var(--border-radius-large);
  cursor: pointer;
}
.textarea__input[data-v-219a1ffb]:active:not([disabled]),
.textarea__input[data-v-219a1ffb]:hover:not([disabled]),
.textarea__input[data-v-219a1ffb]:focus:not([disabled]) {
  border-color: 2px solid var(--color-main-text) !important;
  box-shadow: 0 0 0 2px var(--color-main-background) !important;
}
.textarea__input[data-v-219a1ffb]:not(:focus, .textarea__input--label-outside)::placeholder {
  opacity: 0;
}
.textarea__input[data-v-219a1ffb]:focus {
  cursor: text;
}
.textarea__input[data-v-219a1ffb]:disabled {
  cursor: default;
}
.textarea__input[data-v-219a1ffb]:focus-visible {
  box-shadow: unset !important;
}
.textarea__input--success[data-v-219a1ffb] {
  border-color: var(--color-success) !important;
}
.textarea__input--success[data-v-219a1ffb]:focus-visible {
  box-shadow:
    #f8fafc 0 0 0 2px,
    var(--color-primary-element) 0 0 0 4px,
    #0000000d 0 1px 2px;
}
.textarea__input--error[data-v-219a1ffb] {
  border-color: var(--color-error) !important;
}
.textarea__input--error[data-v-219a1ffb]:focus-visible {
  box-shadow:
    #f8fafc 0 0 0 2px,
    var(--color-primary-element) 0 0 0 4px,
    #0000000d 0 1px 2px;
}
.textarea__label[data-v-219a1ffb] {
  position: absolute;
  margin-inline: 12px 0;
  max-width: fit-content;
  inset-block-start: 11px;
  inset-inline: 0;
  color: var(--color-text-maxcontrast);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
  transition:
    height var(--animation-quick),
    inset-block-start var(--animation-quick),
    font-size var(--animation-quick),
    color var(--animation-quick),
    background-color var(--animation-quick) var(--animation-slow);
}
.textarea__input:focus + .textarea__label[data-v-219a1ffb],
.textarea__input:not(:placeholder-shown) + .textarea__label[data-v-219a1ffb] {
  inset-block-start: -10px;
  line-height: 1.5;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-main-text);
  background-color: var(--color-main-background);
  padding-inline: 4px;
  margin-inline-start: 8px;
  transition:
    height var(--animation-quick),
    inset-block-start var(--animation-quick),
    font-size var(--animation-quick),
    color var(--animation-quick);
}
.textarea__helper-text-message[data-v-219a1ffb] {
  padding-block: 4px;
  display: flex;
  align-items: center;
}
.textarea__helper-text-message__icon[data-v-219a1ffb] {
  margin-inline-end: 8px;
}
.textarea__helper-text-message--error[data-v-219a1ffb] {
  color: var(--color-error-text);
}
.textarea__helper-text-message--success[data-v-219a1ffb] {
  color: var(--color-success-text);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcTextArea-DitXCroY.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,wBAAwB;EACxB,WAAW;EACX,mCAAmC;EACnC,uBAAuB;EACvB,8CAA8C;EAC9C,6BAA6B;EAC7B,iDAAiD;EACjD,yCAAyC;EACzC,eAAe;AACjB;AACA;;;EAGE,yDAAyD;EACzD,6DAA6D;AAC/D;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6CAA6C;AAC/C;AACA;EACE;;;uBAGqB;AACvB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE;;;uBAGqB;AACvB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB;;;;;iEAK+D;AACjE;AACA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,8CAA8C;EAC9C,mBAAmB;EACnB,wBAAwB;EACxB;;;;gCAI8B;AAChC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-219a1ffb] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.textarea[data-v-219a1ffb] {\n  position: relative;\n  width: 100%;\n  border-radius: var(--border-radius-large);\n  margin-block-start: 6px;\n  resize: vertical;\n}\n.textarea__main-wrapper[data-v-219a1ffb] {\n  position: relative;\n}\n.textarea--disabled[data-v-219a1ffb] {\n  opacity: .7;\n  filter: saturate(.7);\n}\n.textarea__input[data-v-219a1ffb] {\n  margin: 0;\n  padding-inline: 10px 6px;\n  width: 100%;\n  font-size: var(--default-font-size);\n  text-overflow: ellipsis;\n  background-color: var(--color-main-background);\n  color: var(--color-main-text);\n  border: 2px solid var(--color-border-maxcontrast);\n  border-radius: var(--border-radius-large);\n  cursor: pointer;\n}\n.textarea__input[data-v-219a1ffb]:active:not([disabled]),\n.textarea__input[data-v-219a1ffb]:hover:not([disabled]),\n.textarea__input[data-v-219a1ffb]:focus:not([disabled]) {\n  border-color: 2px solid var(--color-main-text) !important;\n  box-shadow: 0 0 0 2px var(--color-main-background) !important;\n}\n.textarea__input[data-v-219a1ffb]:not(:focus, .textarea__input--label-outside)::placeholder {\n  opacity: 0;\n}\n.textarea__input[data-v-219a1ffb]:focus {\n  cursor: text;\n}\n.textarea__input[data-v-219a1ffb]:disabled {\n  cursor: default;\n}\n.textarea__input[data-v-219a1ffb]:focus-visible {\n  box-shadow: unset !important;\n}\n.textarea__input--success[data-v-219a1ffb] {\n  border-color: var(--color-success) !important;\n}\n.textarea__input--success[data-v-219a1ffb]:focus-visible {\n  box-shadow:\n    #f8fafc 0 0 0 2px,\n    var(--color-primary-element) 0 0 0 4px,\n    #0000000d 0 1px 2px;\n}\n.textarea__input--error[data-v-219a1ffb] {\n  border-color: var(--color-error) !important;\n}\n.textarea__input--error[data-v-219a1ffb]:focus-visible {\n  box-shadow:\n    #f8fafc 0 0 0 2px,\n    var(--color-primary-element) 0 0 0 4px,\n    #0000000d 0 1px 2px;\n}\n.textarea__label[data-v-219a1ffb] {\n  position: absolute;\n  margin-inline: 12px 0;\n  max-width: fit-content;\n  inset-block-start: 11px;\n  inset-inline: 0;\n  color: var(--color-text-maxcontrast);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  pointer-events: none;\n  transition:\n    height var(--animation-quick),\n    inset-block-start var(--animation-quick),\n    font-size var(--animation-quick),\n    color var(--animation-quick),\n    background-color var(--animation-quick) var(--animation-slow);\n}\n.textarea__input:focus + .textarea__label[data-v-219a1ffb],\n.textarea__input:not(:placeholder-shown) + .textarea__label[data-v-219a1ffb] {\n  inset-block-start: -10px;\n  line-height: 1.5;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--color-main-text);\n  background-color: var(--color-main-background);\n  padding-inline: 4px;\n  margin-inline-start: 8px;\n  transition:\n    height var(--animation-quick),\n    inset-block-start var(--animation-quick),\n    font-size var(--animation-quick),\n    color var(--animation-quick);\n}\n.textarea__helper-text-message[data-v-219a1ffb] {\n  padding-block: 4px;\n  display: flex;\n  align-items: center;\n}\n.textarea__helper-text-message__icon[data-v-219a1ffb] {\n  margin-inline-end: 8px;\n}\n.textarea__helper-text-message--error[data-v-219a1ffb] {\n  color: var(--color-error-text);\n}\n.textarea__helper-text-message--success[data-v-219a1ffb] {\n  color: var(--color-success-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
